import { styled } from '@/stitches.config';

const RootContainer = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '$2',
  width: 'fit-content',
});

const ColorBlock = styled('div', {
  borderRadius: '2px',
  width: '$4',
  height: '$4',
});

const Label = styled('span', {
  fontSize: '$4',
  color: '$darkBlue400',
  fontWeight: '$medium',
});

export interface ChartColorDescriptionProps {
  color: string;
  label: string;
}

export const ChartColorDescription = ({ color, label }: ChartColorDescriptionProps): JSX.Element => {
  return (
    <RootContainer>
      <ColorBlock css={{ background: color }} data-testid="color-container" />
      <Label>{label}</Label>
    </RootContainer>
  );
};
